// Returns status string for an OKR given its keyResults and deadline
export function calculateOKRStatus(keyResults, deadline) {
  const total = keyResults.length;
  const done = keyResults.filter(kr => kr.completed).length;
  const now = new Date();
  const dl = deadline ? new Date(deadline) : null;

  if (total > 0 && done === total) return 'Complete';
  if (done === 0) return 'Not Started';
  if (!dl) return 'On Track';

  const msLeft = dl - now;
  const daysLeft = msLeft / (1000 * 60 * 60 * 24);

  if (daysLeft < -3) return 'Back Burner';
  if (daysLeft < 0) return 'Behind';
  if (daysLeft <= 3) return 'At Risk';
  return 'On Track';
}

// Status icon, color, and tooltip mapping for UI/UX - Material 3 Tonal Variants
export const OKR_STATUS_META = {
  'On Track': {
    icon: '✅',
    color: '#1E8E3E',
    bg: '#E8F5E9',
    border: '#1E8E3E',
    tooltip: 'On Track: Progress is on schedule.'
  },
  'At Risk': {
    icon: '⚠️',
    color: '#F9A825',
    bg: '#FFF8E1',
    border: '#F9A825',
    tooltip: 'At Risk: Deadline is close, progress may be delayed.'
  },
  'Behind': {
    icon: '🟥',
    color: '#C62828',
    bg: '#FFEBEE',
    border: '#C62828',
    tooltip: 'Behind: Past deadline, not enough progress.'
  },
  'Not Started': {
    icon: '💤',
    color: '#90A4AE',
    bg: '#F5F5F5',
    border: '#90A4AE',
    tooltip: 'Not Started: No key results completed yet.'
  },
  'Back Burner': {
    icon: '🔥',
    color: '#6D4C41',
    bg: '#F5F5F5',
    border: '#6D4C41',
    tooltip: 'Back Burner: Significantly overdue or deprioritized.'
  },
  'Complete': {
    icon: '✅',
    color: '#1976D2',
    bg: '#E3F2FD',
    border: '#1976D2',
    tooltip: 'Complete: All key results finished.'
  }
}; 